// Queen Dollar data access. Talks ONLY to the qd_* tables/RPCs (Admin only, enforced by the database).
// Standalone: never to Accounts, Sales, staff/payroll or any other module.
import { supabase } from "../supabase";

const fail = (error) => { const e = new Error(error.message || "Request failed"); e.code = error.code; throw e; };
const rpc = async (fn, args) => {
    const { data, error } = await supabase.rpc(fn, args);
    if (error) fail(error);
    return data;
};

export async function loadQd() {
    const [records, settings, summary] = await Promise.all([
        supabase.from("qd_records").select("*").order("record_date", { ascending: false }).order("created_at", { ascending: false }),
        supabase.from("qd_settings").select("*").maybeSingle(),
        supabase.rpc("qd_summary"),
    ]);
    for (const r of [records, settings, summary]) if (r.error) fail(r.error);
    return { records: records.data || [], settings: settings.data, summary: (summary.data || [])[0] || { record_count: 0, total_usd: 0, total_npr: 0 } };
}

export const saveRecord = (p) => rpc("qd_save_record", { p });
export const deleteRecord = (id) => rpc("qd_delete_record", { p_id: id });
export const restoreRecord = (id) => rpc("qd_restore_record", { p_id: id });
export const setDefaultRate = (rate) => rpc("qd_set_default_rate", { p_rate: rate });

export const errText = (e) => {
    const m = e?.message || String(e || "");
    if (/Admin only|permission denied|42501/i.test(m) && !/can't|deleted/i.test(m)) return "Queen Dollar is available to Admin only.";
    if (/Failed to fetch|NetworkError/i.test(m)) return "Couldn't reach the server. Check the connection and try again.";
    return m;
};
